module.exports = __webpack_public_path__ + "img/k2.15e79fd2.png";